import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import { whiteboardSettingPushed } from 'features/whiteboard/actions';
import { selectWhiteboardId, selectWhiteboardOpen } from 'features/whiteboard/whiteboardSlice';
import { WhiteboardMode } from 'utils/whiteboard/settings';
import { useAppDispatch, useAppSelector } from 'store/hooks';

const SyncWhiteboardThemeModal = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const modalData = useAppSelector(selectActiveModalData);
  const mode = modalData.mode as WhiteboardMode;

  const { hasPermissions } = usePermissions();

  const whiteboardOpen = useAppSelector(selectWhiteboardOpen);
  const whiteboardId = useAppSelector(selectWhiteboardId);

  const shouldClose =
    !hasPermissions(PermissionTypes.editWhiteboard) ||
    !whiteboardOpen ||
    whiteboardId !== modalData.whiteboardId;

  useEffect(() => {
    if (shouldClose) {
      dispatch(closeModal('syncWhiteboardTheme'));
    }
  }, [shouldClose, dispatch]);

  const handleConfirm = () => {
    dispatch(whiteboardSettingPushed({ key: 'mode', value: mode }));
    dispatch(closeModal('syncWhiteboardTheme'));
  };

  const handleCancel = () => {
    dispatch(closeModal('syncWhiteboardTheme'));
  };

  return (
    <ConfirmationDialog
      open={!shouldClose}
      hideCloseButton
      preventClose
      title={t('sync_whiteboard_theme.title')}
      description={t('sync_whiteboard_theme.description')}
      okText={t('sync_whiteboard_theme.btn_ok_label')}
      onOk={handleConfirm}
      cancelText={t('sync_whiteboard_theme.btn_cancel_label')}
      onCancel={handleCancel}
    />
  );
};

export default SyncWhiteboardThemeModal;
